var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNiurixlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.549,
    height: 26.426,
    viewBox: "0 0 80.549 26.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "niurixlogo",
    transform: "translate(0.01 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,19.751c.65-.026,1.3-.045,1.954-.082.321-.019.389.123.381.418-.015.96-.007,1.924-.007,3.011.183-.205.3-.329.415-.463A8.187,8.187,0,0,1,9.183,19.3a6.417,6.417,0,0,1,6.59,5.481c.12.658.176,1.326.273,1.987.045.318-.06.463-.4.448-.512-.019-1.027-.022-1.539-.007-.329.011-.318-.205-.351-.426a14.544,14.544,0,0,0-.4-2.331c-.676-2.062-2.085-2.9-4.248-3.041a6.473,6.473,0,0,0-6.433,4.972c-.172.837-.213.837-1.091.826C1.054,27.2.527,27.156,0,27.13V19.748Z",
    transform: "translate(-0.006 -12.14)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-.006,46.26c.635.007,1.274.026,1.909.011.318-.007.43.082.426.422Q2.3,50.638,2.31,54.58c0,.362-.12.46-.456.452-.62-.015-1.24.007-1.864.011V46.26Z",
    transform: "translate(0 -29.1)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M159.774-.006a7.372,7.372,0,0,1,1.068.728,1.766,1.766,0,0,1,.254,2.189,1.942,1.942,0,0,1-1.976.938,2.057,2.057,0,0,1-1.569-1.76A1.843,1.843,0,0,1,158.721.207c.138-.056.265-.146.4-.217h.654Z",
    transform: "translate(-98.966 0)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M56.218,0a7.921,7.921,0,0,1,.9.557,1.791,1.791,0,0,1,.486,2.189,2.019,2.019,0,0,1-1.931,1.121,2.074,2.074,0,0,1-1.7-1.636A1.9,1.9,0,0,1,55.086.265c.164-.075.321-.176.478-.265Z",
    transform: "translate(-33.902 -0.006)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M74.85,46.341h2.316c.052.743.067,1.457.153,2.156a5.191,5.191,0,0,0,5.032,4.8,5.75,5.75,0,0,0,4.778-1.621,5.159,5.159,0,0,0,1.412-3.459c.037-.512.034-1.027.093-1.535a.492.492,0,0,1,.314-.351c.646-.034,1.3-.015,2.051-.015-.075.833-.127,1.6-.22,2.365a7.874,7.874,0,0,1-1.55,4.083,6.95,6.95,0,0,1-4.076,2.522,9.514,9.514,0,0,1-5.025-.153A7.049,7.049,0,0,1,75.1,48.9c-.123-.841-.168-1.692-.25-2.567Z",
    transform: "translate(-47.046 -29.129)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M188.63,55.018c-.852,0-1.625.022-2.395-.019a.882.882,0,0,1-.534-.37c-1.76-2.413-3.5-4.838-5.249-7.259-.034-.049-.082-.09-.157-.179-.62.856-1.225,1.689-1.827,2.525-1.166,1.614-2.335,3.224-3.482,4.853a.939.939,0,0,1-.889.452c-.661-.022-1.322-.007-2.107-.007.164-.235.262-.377.362-.519,1.8-2.514,3.62-5.021,5.4-7.55a1.427,1.427,0,0,1,1.352-.7c.915.041,1.838-.019,2.753.03a1.145,1.145,0,0,1,.773.385c1.917,2.589,3.8,5.2,5.693,7.8a6.28,6.28,0,0,1,.31.549Z",
    transform: "translate(-108.098 -29.091)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M173.83,20.276c.8,0,1.577-.026,2.346.019a.9.9,0,0,1,.545.377c1.375,1.868,2.731,3.747,4.095,5.623.183.25.381.489.613.785a5.191,5.191,0,0,0,.4-.452c1.382-1.92,2.768-3.837,4.132-5.768a1.163,1.163,0,0,1,1.147-.609c.624.056,1.259.011,1.961.011-.09.157-.131.25-.191.332-1.573,2.185-3.157,4.36-4.715,6.556a1.362,1.362,0,0,1-1.278.661c-1.072-.041-2.148,0-3.22-.026a.9.9,0,0,1-.635-.269c-1.741-2.35-3.456-4.718-5.174-7.083-.015-.022-.008-.06-.019-.161Z",
    transform: "translate(-109.25 -12.733)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M132.547,22.279c.209-.258.411-.523.628-.773a5.638,5.638,0,0,1,3.519-2.185,3.564,3.564,0,0,1,2.522.579c-.344.564-.669,1.121-1.027,1.659a.458.458,0,0,1-.392.086,3.49,3.49,0,0,0-3.926,1.513,7.183,7.183,0,0,0-1.248,3.564c-.026.314-.149.456-.452.456-.639,0-1.274.011-1.913.015-.329,0-.258-.25-.258-.437V20.919c0-.3.015-.594,0-.885s.1-.381.381-.374c.56.011,1.121.011,1.681-.007.288-.011.389.1.377.377-.019.575-.022,1.151-.026,1.726,0,.161.015.318.022.478l.12.041Z",
    transform: "translate(-81.676 -12.131)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M130.06,55.081V46.324c.728,0,1.442-.015,2.148.019.09,0,.232.262.235.4.015.87-.007,1.745-.007,2.615,0,1.726-.011,3.456,0,5.182,0,.422-.127.579-.564.549C131.285,55.051,130.7,55.081,130.06,55.081Z",
    transform: "translate(-81.697 -29.139)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M161.832,46.272v1.715c0,2.163-.007,4.326.019,6.489,0,.463-.146.6-.59.564a7.459,7.459,0,0,0-1.259,0c-.381.03-.486-.112-.482-.474.019-1.278.015-2.552.015-3.829,0-1.323.007-2.645-.007-3.968,0-.366.071-.534.489-.5.583.045,1.173.011,1.812.011Z",
    transform: "translate(-100.2 -29.101)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M56.08,46.3c.7,0,1.367-.015,2.032.019.09,0,.243.25.243.385.011,1-.019,1.991-.022,2.989q0,2.5.019,4.995c0,.243-.052.385-.332.377-.635-.011-1.27,0-1.939,0V46.3Z",
    transform: "translate(-35.23 -29.126)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M37.05,55.086V46.337c.687,0,1.364-.011,2.04.019.075,0,.2.247.2.381.011.964,0,1.928,0,2.892,0,1.666-.007,3.329.007,4.995,0,.362-.093.5-.471.474-.572-.034-1.147-.007-1.771-.007Z",
    transform: "translate(-23.215 -29.147)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M114.095,20.369V21.68c0,1.913,0,3.826.019,5.735,0,.37-.1.5-.471.474a14.352,14.352,0,0,0-1.446,0c-.318.011-.437-.09-.433-.422q.017-3.334,0-6.665c0-.347.09-.456.452-.433.616.037,1.233.011,1.887.011Z",
    transform: "translate(-70.203 -12.808)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M159.646,20.29h1.864c.288,0,.37.149.37.411q-.006,3.385,0,6.766c0,.28-.1.389-.381.381-.527-.015-1.057.015-1.584-.019-.123-.007-.34-.194-.34-.3-.015-2.331-.007-4.666,0-7a.954.954,0,0,1,.075-.239Z",
    transform: "translate(-100.23 -12.763)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M74.767,24.23c0-1.087.011-2.174-.007-3.265-.007-.347.1-.467.452-.448.512.026,1.027.015,1.539,0,.318-.011.437.09.433.422-.015,2.129-.015,4.259-.015,6.388,0,.564-.078.65-.643.654-.418,0-.841-.026-1.259,0-.385.026-.512-.09-.5-.489.03-1.087.011-2.174.011-3.265h-.007Z",
    transform: "translate(-46.962 -12.904)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M56.094,20.294c.7,0,1.371-.015,2.032.019.093,0,.25.239.25.37,0,1.027-.034,2.055-.034,3.082,0,1.136.022,2.271.041,3.407.011.68.015.68-.684.676H56.09V20.3Z",
    transform: "translate(-35.236 -12.763)",
    fill: "#1d1d1d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiurixlogo);
export default __webpack_public_path__ + "static/media/niurixlogo.95e4965f73da719a40d85905d0afbaff.svg";
export { ForwardRef as ReactComponent };